import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;

// import React from "react";
import styled from "styled-components";
export default styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  margin-top: 8px;\n  padding: 16px;\n  flex: 1;\n  background: #fff;\n  overflow-y: auto;\n"])));